<template>
  <v-footer class="core-footer font-weight-medium light" height="60">
    <v-row fixed justify="space-between" no-gutters>
      <v-col cols="12" md="4" order="1">
        <v-row align="center" justify="center" class="footer-items"> </v-row>
      </v-col>
      <v-col align="center" cols="12" md="4" order="2">
        <span class="font-weight-light copyright">
          &copy;
          {{ new Date().getFullYear() }}
          PARTICIPA INTELIGENTE
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {};
</script>
<style>
#core-footer {
  z-index: 0;
}
</style>
